import { isNil } from 'lodash'

import { pick } from '@eastcoal/common/utils/object'

import { useAuthStore } from '../useStore'

/**
 * 是否属于当前用户的数据
 */
export const useBelongOwnData = (creatorProfileId?: string) => {
  const { profileId, administrator, superAdministrator } = useAuthStore(state =>
    pick(state, ['profileId', 'administrator', 'superAdministrator'])
  )

  if (administrator || superAdministrator) {
    return true
  }

  return isNil(creatorProfileId) ? true : creatorProfileId === profileId
}
